module.exports = __webpack_public_path__ + "static/media/Community.a082011d.svg";